import axios from "./AxiosInstance"

const getType = () => axios.get("api/activityTypes")
const getState = () => axios.get("api/activityState")
const getSports = () => axios.get("api/sports")
const createSport = (sportName) => axios.post("api/sports", { name: sportName })
const create = (data) => axios.post("api/activityPlannings", { ...data })
const update = (activityid, data) => axios.put(`api/activities/${activityid}`, { ...data })
const getPatientsActivity = (userId, date) => axios.get(`api/activities?patientId=${userId}&date=${date}`)

const getActivityRate = (userId, startDate, endDate) =>
    axios.get(addStartAndEndDate(`api/patients/${userId}/activityRate`, startDate, endDate, false))
const getActivityHour = (userId, startDate, endDate) =>
    axios.get(addStartAndEndDate(`api/patients/${userId}/activityHour`, startDate, endDate, false))
const getActivityEnduranceHour = (userId, startDate, endDate) =>
    axios.get(addStartAndEndDate(`api/patients/${userId}/activityHour?activityTypeCode=ENDURANCE`, startDate, endDate))
const getActivityRenforcementHour = (userId, startDate, endDate) =>
    axios.get(
        addStartAndEndDate(`api/patients/${userId}/activityHour?activityTypeCode=RENFORCEMENT`, startDate, endDate)
    )
const getActivityCount = (userId, startDate, endDate) =>
    axios.get(addStartAndEndDate(`api/patients/${userId}/activityCount`, startDate, endDate, false))
const getActivityEnduranceCount = (userId, startDate, endDate) =>
    axios.get(addStartAndEndDate(`api/patients/${userId}/activityCount?activityTypeCode=ENDURANCE`, startDate, endDate))
const getActivityRenforcementCount = (userId, startDate, endDate) =>
    axios.get(
        addStartAndEndDate(`api/patients/${userId}/activityCount?activityTypeCode=RENFORCEMENT`, startDate, endDate)
    )

const getActivityDetailsDistance = (userId, startDate, endDate) =>
    axios.get(addStartAndEndDate(`api/patients/${userId}/detailsDistance`, startDate, endDate, false))
const getActivityDetailsDuration = (userId, startDate, endDate) =>
    axios.get(addStartAndEndDate(`api/patients/${userId}/detailsDuration`, startDate, endDate, false))

const addStartAndEndDate = (url, startDate, endDate, hasAdditionnalParams = true) => {
    let finalUrl = url
    if (startDate && endDate) {
        finalUrl = `${url}${hasAdditionnalParams ? "&" : "?"}startDate=${startDate}&endDate=${endDate}`
    }
    return finalUrl
}

export const ActivityService = {
    getState,
    getType,
    getSports,
    createSport,
    create,
    update,
    getPatientsActivity,
    getActivityRate,
    getActivityCount,
    getActivityHour,
    getActivityDetailsDistance,
    getActivityDetailsDuration,
    getActivityEnduranceCount,
    getActivityEnduranceHour,
    getActivityRenforcementCount,
    getActivityRenforcementHour
}
